import React from 'react';
import { ReactComponent as GroupImg } from 'utils/app/assets/icons/Group.svg';
import { ReactComponent as ArchiveImg } from 'utils/app/assets/icons/Archive.svg';
import { ReactComponent as RadioDeviceImg } from 'utils/app/assets/icons/RadioDevice.svg';

interface MenuIconProps {
    className?: string;
    style?: React.CSSProperties;
}

export const MenuIcons = {
    device: ({ className, style }: MenuIconProps) => (
        <RadioDeviceImg
            className={className}
            style={{
                width: 14,
                height: 14,
                marginRight: 8,
                ...style,
            }}
        />
    ),
    group: ({ className, style }: MenuIconProps) => (
        <GroupImg
            className={className}
            style={{
                width: 14,
                height: 14,
                marginRight: 8,
                ...style,
            }}
        />
    ),
    unsorted: ({ className, style }: MenuIconProps) => (
        <ArchiveImg
            className={className}
            style={{
                width: 14,
                height: 14,
                marginRight: 8,
                ...style,
            }}
        />
    ),
};
